import { SvgIconType } from './svg.interface';

const PrerequisiteIcon: SvgIconType = ({
  width = 32,
  height = 32,
  className = '',
  color = '#A3ACBA'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="6" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 10.999L16 7.99902L9 10.999L9.4274 15.7004C9.77524 19.5267 12.3552 22.7841 16 23.999C19.7091 22.7879 22.3265 19.4656 22.6359 15.576L23 10.999ZM20.4975 12.9942C20.107 12.6037 19.4738 12.6037 19.0833 12.9942L15 17.0848L13.2071 15.2919C12.8166 14.9014 12.1834 14.9014 11.7929 15.2919C11.4024 15.6824 11.4024 16.3156 11.7929 16.7061L14.2929 19.2061C14.6834 19.5967 15.3166 19.5967 15.7071 19.2061L20.4975 14.4084C20.888 14.0179 20.888 13.3848 20.4975 12.9942Z"
      fill="white"
    />
  </svg>
);

export default PrerequisiteIcon;
